import { render, staticRenderFns } from "./DocumentOptions.vue?vue&type=template&id=26da2850&scoped=true"
import script from "./DocumentOptions.vue?vue&type=script&lang=js"
export * from "./DocumentOptions.vue?vue&type=script&lang=js"
import style0 from "./DocumentOptions.vue?vue&type=style&index=0&id=26da2850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26da2850",
  null
  
)

export default component.exports